var _g, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgConnect(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 18,
    height: 12,
    viewBox: "0 0 18 12",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_9620_16896)"
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M7.05025 1.05025C7.32086 0.779646 7.61134 0.533484 7.91826 0.313187C7.31594 0.11009 6.67083 0 6 0C2.68629 0 0 2.68629 0 6C0 9.31371 2.68629 12 6 12C9.31371 12 12 9.31371 12 6C12 4.67208 11.5686 3.44491 10.8383 2.451C10.3368 2.59753 9.87554 2.83745 9.48623 3.1544C10.1199 3.9298 10.5 4.92051 10.5 6C10.5 8.48528 8.48528 10.5 6 10.5C3.51472 10.5 1.5 8.48528 1.5 6C1.5 3.51472 3.51472 1.5 6 1.5C6.205 1.5 6.40681 1.51371 6.60454 1.54026C6.74471 1.37069 6.89337 1.20713 7.05025 1.05025Z",
    fill: "#55595F"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M12 10.5C14.4853 10.5 16.5 8.48528 16.5 6C16.5 3.51472 14.4853 1.5 12 1.5C9.51472 1.5 7.5 3.51472 7.5 6C7.5 7.07949 7.88011 8.07021 8.51378 8.84561C8.20402 9.0978 7.84547 9.30392 7.45168 9.45221C7.35646 9.48806 7.2597 9.52034 7.16165 9.54897C6.43138 8.55506 6 7.32791 6 6C6 2.68629 8.68629 0 12 0C15.3137 0 18 2.68629 18 6C18 9.31371 15.3137 12 12 12C11.3292 12 10.684 11.8899 10.0817 11.6868C10.3899 11.4656 10.6803 11.2192 10.9497 10.9497C11.1062 10.7933 11.2549 10.6297 11.3954 10.4597C11.5932 10.4863 11.795 10.5 12 10.5Z",
    fill: "#55595F"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_9620_16896"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 18,
    height: 12,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgConnect);
export default __webpack_public_path__ + "static/media/Connect.00773caf0f3348e3afa955267afc8a72.svg";
export { ForwardRef as ReactComponent };